import { render, staticRenderFns } from "./NuevoPaciente.vue?vue&type=template&id=37a5d77d"
import script from "./NuevoPaciente.vue?vue&type=script&lang=js"
export * from "./NuevoPaciente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports